<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sA6eny/tc-custom/9781504010603.jpg?1703649188319" alt="This image is the cover for the book Henrietta Who?, The Calleshire Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Henrietta Who?, The Calleshire Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <b>A hit-and-run murder unearths a case of mistaken identity in this “</b><b>well-bred, well written and genuinely superior” mystery by the Diamond Dagger winner (<i>Kirkus Reviews</i>).</b><br/><br/> Early one morning in the quiet English village of Larking, the body of a woman named Mrs. Jenkins is found in the road. Miles away, her daughter, Henrietta, receives the bad news while working in the university library. Poor Mrs. Jenkins appears to have been the victim of a horrible car accident.<br/>  <br/> When an autopsy proves not only that this was no accident but also that Mrs. Jenkins had never had a child, young Henrietta’s life is thrown upside down. If she’s not Mrs. Jenkins’s daughter, then who is she? It’s up to Detective Inspector C. D. Sloan of the Calleshire police force to bring the murderer to justice—and a sense of order back to Henrietta’s life.<br/>  <br/> Proclaimed by the <i>New York Times</i> in 1968 to be one of the year’s best books, <i>Henrietta Who? </i>is a first-order English whodunit that’ll keep you guessing until the end.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Catherine Aird
      </h2>
      
      <p class="authorDescription body article">Catherine Aird is the author of more than twenty volumes of detective mysteries and three collections of short stories. Most of her fiction features Detective Inspector C. D. Sloan and Detective Constable W. E. Crosby.&#160;Aird holds an honorary master&rsquo;s degree from the University of Kent and was made a&#160;Member of the Most Excellent Order of the British Empire&#160;(MBE) for her services to the Girl Guide Association. She lives in a village in East Kent, England.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5db60773